import Vue, { DirectiveOptions } from "vue";
import "normalize.css";
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/icon.css'
import SvgIcon from "vue-svgicon";
import "@/styles/element-variables.scss";
import "@/styles/index.scss";
import "@/styles/customer-console.scss";
import "@/styles/admin-console.scss";
import App from "@/App.vue";
import store from "@/store";
import { AppModule } from "@/store/modules/app";
import router from "@/router";
import i18n from "@/lang";
import "@/icons/components";
import "@/permission";
import { dealImage } from "@/utils"
import Load from "@/utils/load/loading";
import * as directives from "@/directives";
import * as filters from "@/filters";
import * as api from "@/api/api";
import md5 from 'js-md5';

/*
* 自定义组件
*/
import WeSearch from "@/components/We/search.vue"
import Pagination from "@/components/We/pagination/index"
import AdminRowActions from "@/components/common/RowActions";

// 全局挂载接口
Vue.prototype.$http = api;
Vue.prototype.$md5 = md5;
Vue.prototype.$bus = new Vue()
Vue.prototype.$thumbnailImage = dealImage;

// 兼容各国语言、以及窗口布局的size
Vue.use(ElementUI, {
    size: AppModule.size, // Set element-ui default size
    i18n: (key: string, value: string) => i18n.t(key, value)
});

// 全局挂在loading
Vue.use(Load);

// 全局注册svg图标组件
Vue.use(SvgIcon, {
    tagName: "svg-icon",
    defaultWidth: "1em",
    defaultHeight: "1em"
});

/*
 * 全局注册自定义指令
*/
Object.keys(directives).forEach(key => {
    Vue.directive(key, (directives as { [key: string]: DirectiveOptions })[key]);
});

/*
 * 全局注册过滤器
*/
Object.keys(filters).forEach(key => {
    Vue.filter(key, (filters as { [key: string]: Function })[key]);
});

Vue.config.productionTip = false;
document.body.classList.add('platform-admin');

// 全局注册组件
Vue.component("we-search", WeSearch)
Vue.component("we-pagination", Pagination)
Vue.component("admin-row-actions", AdminRowActions);

Vue.config.errorHandler = (err, vm, info) => {
    if (err.message && err.message.includes('[ElementForm]unpected width')) {
        //console.warn('忽略 ElementForm 宽度计算错误')
        return false
    }
    console.error('Vue error:', err)
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");
